const ShanghaiTower49F = 205766

export const JPMCKioskAccess: number[] = [ShanghaiTower49F]

export const keys = [
  'background_image',
  'background_video',
  'enable_background_video',
  'data_panel_position',
  'data_panel_opacity',
  'theme_color',
  'font_color',
  'font',
  'logo_image',
  'locked',
  'password',
  'background_full_screen',
  'use_aqi',
  'hide_location_average',
  'show_qr_code',
  'show_health_rating',
  'historical_data_limit',
  'enable_home_button',
  'show_download_button',
  'show_notification_button',
  'show_menu_contact_us',
  'show_menu_profile',
  'show_menu_more',
  'kiosk_information',
  'location_information'
]
